/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct(value) {
    if (!('Url' in value) || value['Url'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('ProductName' in value) || value['ProductName'] === undefined)
        return false;
    if (!('ProductDescription' in value) || value['ProductDescription'] === undefined)
        return false;
    if (!('LocalizedProductName' in value) || value['LocalizedProductName'] === undefined)
        return false;
    if (!('LocalizedProductDescription' in value) || value['LocalizedProductDescription'] === undefined)
        return false;
    if (!('Quantity' in value) || value['Quantity'] === undefined)
        return false;
    if (!('ImageUrl' in value) || value['ImageUrl'] === undefined)
        return false;
    if (!('IconUrl' in value) || value['IconUrl'] === undefined)
        return false;
    if (!('ShowInWebStore' in value) || value['ShowInWebStore'] === undefined)
        return false;
    if (!('Price' in value) || value['Price'] === undefined)
        return false;
    if (!('DefaultCurrencyPrice' in value) || value['DefaultCurrencyPrice'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Url': json['url'],
        'Sku': json['sku'],
        'ProductName': json['product_name'],
        'ProductDescription': json['product_description'],
        'LocalizedProductName': json['localized_product_name'],
        'LocalizedProductDescription': json['localized_product_description'],
        'Payload': json['payload'] == null ? undefined : json['payload'],
        'Quantity': json['quantity'],
        'ImageUrl': json['image_url'],
        'IconUrl': json['icon_url'],
        'ShowInWebStore': json['show_in_web_store'],
        'Price': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSON(json['price']),
        'DefaultCurrencyPrice': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSON(json['default_currency_price']),
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['Url'],
        'sku': value['Sku'],
        'product_name': value['ProductName'],
        'product_description': value['ProductDescription'],
        'localized_product_name': value['LocalizedProductName'],
        'localized_product_description': value['LocalizedProductDescription'],
        'payload': value['Payload'],
        'quantity': value['Quantity'],
        'image_url': value['ImageUrl'],
        'icon_url': value['IconUrl'],
        'show_in_web_store': value['ShowInWebStore'],
        'price': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSON(value['Price']),
        'default_currency_price': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSON(value['DefaultCurrencyPrice']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct.js.map